const MULTIPLIERS = {
  kkk: 1_000_000_000,
  kk: 1_000_000,
  k: 1_000,
};

/**
 * Converte uma string de gold no formato Priston Tale ("500k", "1.5kk",
 * "2kkk") para um número inteiro. Aceita também números puros ("1000000").
 */
export function parseGoldInput(input) {
  const normalized = String(input).trim().toLowerCase().replace(',', '.');

  if (normalized === '') {
    throw new Error('Valor de gold vazio');
  }

  const match = normalized.match(/^(\d+(?:\.\d+)?)(kkk|kk|k)?$/);
  if (!match) {
    throw new Error(`Notação de gold inválida: ${input}`);
  }

  const [, numberPart, suffix] = match;
  const multiplier = suffix ? MULTIPLIERS[suffix] : 1;

  return Math.round(parseFloat(numberPart) * multiplier);
}

function trimZeros(value) {
  return value.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
}

/**
 * Formata um número inteiro de gold de volta pra notação curta (k/kk/kkk).
 */
export function formatGold(amount) {
  if (amount < 0) {
    return `-${formatGold(-amount)}`;
  }

  if (amount >= MULTIPLIERS.kkk) {
    return `${trimZeros(amount / MULTIPLIERS.kkk)}kkk`;
  }

  if (amount >= MULTIPLIERS.kk) {
    return `${trimZeros(amount / MULTIPLIERS.kk)}kk`;
  }

  if (amount >= MULTIPLIERS.k) {
    return `${trimZeros(amount / MULTIPLIERS.k)}k`;
  }

  return String(amount);
}
